// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconBucketBottomDiagonals: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="638" height="40" viewBox="0 0 638 40">
            <g fill="none" fillRule="evenodd" opacity=".2" transform="matrix(1 0 0 -1 0 40)">
                <polygon fill="#CCC" points="0 0 638 0 638 40 0 10" />
                <polygon fill="#999" points="0 0 638 0 638 20 0 5" />
            </g>
        </svg>
    );
};

export default React.memo(IconBucketBottomDiagonals);
